import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/** Band pointing single-hub small businesses to Geofleet Lite. */
export default function LiteTeaser() {
  const { t } = useTranslation();

  return (
    <section className="bg-white py-10 lg:py-14" aria-labelledby="lite-teaser-title">
      <div className="mx-auto max-w-7xl px-6">
        <div className="relative flex flex-col gap-6 overflow-hidden rounded-3xl border border-blue-100 bg-gradient-to-r from-blue-50 via-white to-emerald-50/60 p-7 shadow-sm sm:p-9 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex items-start gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-blue-600 text-white shadow-lg shadow-blue-600/25">
              <i className="ri-store-2-line text-2xl" aria-hidden />
            </span>
            <div>
              <h2 id="lite-teaser-title" className="flex flex-wrap items-center gap-2 text-xl font-bold tracking-tight text-gray-900 lg:text-2xl">
                {t('home.liteTeaser.title')}
                <span className="rounded-full bg-blue-600 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">{t('home.liteTeaser.badge')}</span>
              </h2>
              <p className="mt-2 max-w-2xl leading-relaxed text-gray-600">{t('home.liteTeaser.text')}</p>
            </div>
          </div>
          <Link
            to="/lite"
            className="inline-flex shrink-0 items-center justify-center gap-2 self-start rounded-xl bg-gray-900 px-5 py-3 text-sm font-semibold text-white transition-all hover:-translate-y-0.5 hover:bg-gray-800 lg:self-center"
          >
            {t('home.liteTeaser.cta')}
            <i className="ri-arrow-right-line rtl:rotate-180" aria-hidden />
          </Link>
        </div>
      </div>
    </section>
  );
}
